<template>
  <div>
    <v-data-table
      v-if="quoteList.length >= 1"
      :items="quoteList"
      :headers="printableHeaders"
      mobile-breakpoint="20"
      item-key="id"
      hide-default-footer
      :items-per-page="1000"
      :no-data-text="$t('table.noResults')"
      disable-sort
      class="d-none d-print-block"
    >
      <template v-slot:item.calculated_price="{ item }">
        <span :class="item && !item.accepted ? 'text-decoration-line-through' : ''">
          {{ itemAmount(item) }}
        </span>
      </template>
    </v-data-table>

    <v-data-table
      v-if="quoteList.length >= 1"
      @click:row="rowExpand"
      :no-data-text="$t('table.noResults')"
      :items-per-page="1000"
      :headers="headers"
      :items="quoteList"
      class="clickable d-print-none"
      mobile-breakpoint="20"
      item-key="id"
      hide-default-footer
      single-expand
      disable-sort
      show-expand
    >
      <template v-slot:item.item_name="{ item }">
        <span
          :class="item && !item.accepted ? 'text-decoration-line-through' : ''"
          class="d-block text-truncate"
        >
          {{ item && item.item_name ? item.item_name : '---' }}
        </span>
      </template>
      <template v-slot:item.service_report_item_quantity="{ item }">
        <span
          :class="item && !item.accepted ? 'text-decoration-line-through' : ''"
          class="d-block"
        >
          {{
            item && item.service_report_item_quantity
              ? item.service_report_item_quantity
              : '---'
          }}
        </span>
      </template>
      <template v-slot:item.calculated_price="{ item }">
        <span :class="item && !item.accepted ? 'text-decoration-line-through' : ''">
          {{ itemAmount(item) }}
        </span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="ma-0 pa-0">
          <v-card class="pa-5 grey lighten-4" elevation="0" tile flat>
            <v-row v-if="item && item.id !== '1'">
              <v-col cols="4" class="py-0 no-cols">
                <p class="h6 mb-0 grey--text caption">
                  {{ $t('quote.label.category') }}
                </p>
                <p class="body-2">
                  {{
                    item.item_category_name ? item.item_category_name : '---'
                  }}
                </p>
              </v-col>
              <v-col cols="8" class="py-0">
                <p class="h6 mb-0 grey--text caption">
                  {{ $t('quote.label.location') }}
                </p>
                <p class="body-2">
                  {{
                    item.service_report_item_location
                      ? item.service_report_item_location
                      : '---'
                  }}
                </p>
              </v-col>
            </v-row>

            <p class="h6 mb-0 grey--text caption">
              {{ $t('quote.label.itemDescription') }}
            </p>
            <p class="body-2">
              {{ item && item.item_description ? item.item_description : '---' }}
            </p>

            <span v-if="item && item.id !== '1'">
              <p class="h6 mb-0 grey--text caption">
                {{ $t('quote.label.serviceDescription') }}
              </p>
              <p class="body-2 mb-0">
                {{ item && item.service_report_item_description }}
              </p>
            </span>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogMonetary } from '@/util/catalog'
import { quoteTableHeaders, quoteTableHeadersPrintable } from '@/views/quote/listHeaders'

export default {
  name: 'QuotePaymentList',

  props: {
    quoteItemsList: {
      type: Array,
      required: true,
    },

    version: {
      type: Number | String,
      default: 1,
    },
  },

  computed: {
    ...mapGetters(['quoteItems', 'itemsPerPage']),

    hasVendorFee() {
      return this.quoteItems?.vendor_service_charge_fee > 0
    },

    vendorFee() {
      return this.quoteItems?.vendor_service_charge_fee && this.quoteItems?.vendor_service_charge_fee
    },

    vendorFeeData() {
      if (!this.hasVendorFee) return

      return {
        id: '1',
        date_created: '',
        item_id: '1',
        item_name: this.$t('quote.priceTable.serviceCallFee'),
        item_description: this.$t('quote.priceTable.technicalVisitDescription'),
        item_category_id: '',
        item_category_name: '',
        service_report_item_id: '',
        service_report_item_location: '',
        service_report_item_description: '',
        service_report_item_quantity: 1,
        calculated_price: this.vendorFee,
        calculated_by_installment_price: 0,
        accepted: true,
      }
    },

    quoteList() {
      const list = this.quoteItemsList
      if (this.version == 2 && this.hasVendorFee) list.push(this.vendorFeeData)
      return list
    }
  },

  methods: {
    rowExpand(_, slot) {
      slot.expand(!slot.isExpanded)
    },

    itemAmount(item) {
      if (!item) return

      if (this.version == 2) return item.calculated_price ? this.formatMoney(item.calculated_price) : '---'
      else return item.calculated_by_installment_price ? this.formatMoney(item.calculated_by_installment_price) : '---'
    },
  },

  data() {
    return {
      printableHeaders: quoteTableHeadersPrintable,
      formatMoney: catalogMonetary,
      headers: quoteTableHeaders,
    }
  }
}
</script>
